import React, { Component} from 'react'
import axios from 'axios';
import { Line } from 'react-chartjs-2';

class Linecharts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Data: {}
    };
  }
  componentDidMount() {
    axios.get(`https://api.covid19api.com/live/country/sri-lanka/status/confirmed`)
      .then(response => {
        const stats = response.data;
        let Confirmed = [];
        let Active = [];
        let Death = [];
        let Recovered = [];
        let Date = [];
        stats.forEach(stat => {
          Confirmed.push(stat.Confirmed);
          Active.push(stat.Active);
          Death.push(stat.Deaths);
          Recovered.push(stat.Recovered);
          Date.push(stat.Date.split("T")[0]);
        });
        this.setState({
          Data: {
            labels: Date,
            datasets: [
              {
                label: 'Confirmed',
                data: Confirmed,
              borderColor: '#ffc107',
              backgroundColor: 'transparent',
              spanGaps: true,
              borderWidth: 2
              },
              {
                label: 'Active',
                data: Active,
              borderColor: '#17a2b8',
              backgroundColor: 'transparent',
              spanGaps: true,
              borderWidth: 2,
              },
              {
                label: 'Death',
                data: Death,
              borderColor: '#dc3545',
              backgroundColor: 'transparent',
              spanGaps: true,
              borderWidth: 2,
              },
              {
                label: 'Recovered',
                data: Recovered,
              borderColor: '#28a745',
              backgroundColor: 'transparent',
              spanGaps: true,
              borderWidth: 2,
              }
            ]
          }
        });
      })
  }
  render() {
    return (
      <React.Fragment>
      <div className="d-none d-md-block">
      <Line height={158}
      data = {
        this.state.Data
      }
      options = {
        {
          maintainAspectRatio: true,
          responsive: true
        }
      }
      />
      </div>
      <div className="d-block d-sm-none">
      <Line height={300}
      data = {
        this.state.Data
      }
      options = {
        {
          maintainAspectRatio: true,
          responsive: true
        }
      }
      />
      </div>
      </React.Fragment>
    )
  }
}
export default Linecharts